import React from "react";
import {
    RadioGroup,
    Grid,
    TextField,
    Button,
    withStyles,
    Radio,
    MenuItem,
    Checkbox,
    InputLabel,
    Select,
    Input
} from "material-ui";

import {
    FormControl,
    FormHelperText,
    FormControlLabel,
    FormLabel
} from "material-ui/Form";
import Typography from "material-ui/Typography";
import Tooltip from "material-ui/Tooltip";

import styles from "./styles";
import { withRouter } from "react-router-dom";
import { validateFormData } from "../../../../common/formtool";
import { ToInt, ToReal, ToDuration } from "../../../../common/datatypetool";
import { feetToMetersDecimal, metersToFeetDecimal } from "../../../../common/utils";
import { FiberQualificationEnum }  from './fiberqualificationenums'

class FiberQualification extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      allowedSpeedTypes: FiberQualificationEnum.SpeedType.filter(x => x.key > 1),
      lengthLossLimit: this.mapEnumValue(1, "lengthlosslimit"),
      fiberType: this.mapEnumValue(2, "fibertype"),
      speedType: this.mapEnumValue(19, "speedtype"),
      defaultSpeedType: this.mapEnumValue(19, "speedtype"),
      lengthLimit: 1000,
      lossLimit: 0,
      refractiveIndex: 1.493,
      errors: {},
      fiberQualificationInitialised: false,
      fiberQualification: null,
      manualLimits: false,
      testConfig: this.mapEnumValue(0, "testconfig")
    };
  }

  translateElements = (elements) => {
    const { translate } = this.props;
    if (elements !== undefined) {
      elements.forEach(e => {
        e.value = translate(e.value);
      });
    }
    return elements;
  };

  mapEnumValue = (key, type) => {
    switch (type.toLowerCase()) {
      case "lengthlosslimit": {
        return FiberQualificationEnum.LengthLossLimit.filter(
          enumType => enumType.key === parseInt(key)
        );
      }
      case "fibertype": {
        return FiberQualificationEnum.FiberType.filter(
          enumType => enumType.key === parseInt(key)
        );
      }
      case "speedtype": {
        return FiberQualificationEnum.SpeedType.filter(
          enumType => enumType.key === parseInt(key)
        );
      }
      case "testconfig": {
        return FiberQualificationEnum.TestConfig.filter(
          enumType => enumType.key === parseInt(key)
        );
      }

    }
    return [];
  };

  updateAllowedSpeedTypes = (manualLimit, fiberType) => {
    const { fiberQualification, speedType, defaultSpeedType } = this.state;
    let filteredSpeedTypes = []
    if (manualLimit) {
      filteredSpeedTypes = FiberQualificationEnum.SpeedType.filter(x => x.key == 1);
    }
    else if (fiberType <= 1) {
      filteredSpeedTypes = FiberQualificationEnum.SpeedType.filter(x => (x.key > 1 && x.key < 20));
    }
    else {
      filteredSpeedTypes = FiberQualificationEnum.SpeedType.filter(x => x.key > 1);
    }

    this.setState({allowedSpeedTypes: filteredSpeedTypes});

    if (!speedType || !speedType.length || !filteredSpeedTypes || !filteredSpeedTypes.length) {
      return;
    }
    // check last selected speed exists
    let checkSpeedExists = filteredSpeedTypes.filter(x => x.key === speedType[0].key);
    if (checkSpeedExists !== null && checkSpeedExists !== undefined && checkSpeedExists.length > 0) {
      return;
    }

    // check last configured speed exists
    if (fiberQualification) {
      checkSpeedExists = filteredSpeedTypes.filter(x => x.key === parseInt(fiberQualification.fiberlimit));
    }

    if (checkSpeedExists === null || checkSpeedExists === undefined || checkSpeedExists.length <= 0) {
      if (manualLimit) {
        this.setState({speedType: this.mapEnumValue(filteredSpeedTypes[0].key, "speedtype")});
      }
      else {
        this.setState({speedType: defaultSpeedType});
      }
    }
    else {
      this.setState({speedType: this.mapEnumValue(fiberQualification.fiberlimit, "speedtype")});
    }
  }

  updateFiberQualificationStateData = (fiberQualification) => {
    this.setState({
        lengthLossLimit: this.mapEnumValue(fiberQualification.fiberlimit === 1 ? 0 : 1, "lengthlosslimit"),
        fiberType: this.mapEnumValue(fiberQualification.fibertype, "fibertype"),
        speedType: this.mapEnumValue(fiberQualification.fiberlimit, "speedtype"),
        lengthLimit: this.props.lengthMeasurementUnit === "feet" ? Math.round((parseFloat(fiberQualification.maxlength) / 0.3048) * 100) / 100 : parseFloat(fiberQualification.maxlength),
        lossLimit: parseFloat(fiberQualification.fiberattenuation),
        refractiveIndex: parseFloat(fiberQualification.refractiveindex),
        manualLimits: fiberQualification.fiberlimit === 1,
        fiberQualification: fiberQualification,
        testConfig: this.mapEnumValue(fiberQualification.singlefiber === true ? 1 : 0, "testconfig")
    });
    this.updateAllowedSpeedTypes(fiberQualification.fiberlimit === 1, parseInt(fiberQualification.fibertype));
  };

  onChange = e => {
    let validateErrors = this.state.errors;
    const { translate } = this.props;
    const { fiberType, lengthLossLimit } = this.state;
    switch (e.target.name.toLowerCase()) {
        case "lengthlosslimit":
          let enumVal = this.mapEnumValue(e.target.value, "lengthlosslimit");
          let manual = parseInt(e.target.value) === 0;
          this.setState({
            lengthLossLimit: enumVal,
            manualLimits: manual
          });
          if (fiberType && fiberType.length) {
            this.updateAllowedSpeedTypes(manual, parseInt(fiberType[0].key));
          }
          break;
        case "fibertype":
          this.setState({
            fiberType: this.mapEnumValue(e.target.value, "fibertype")
          });
          if (lengthLossLimit && lengthLossLimit.length) {
            this.updateAllowedSpeedTypes(parseInt(lengthLossLimit[0].key) === 0, parseInt(e.target.value));
          }
          break;
        case "speedtype":
          this.setState({
            speedType: this.mapEnumValue(e.target.value, "speedtype")
          });
          break;
        case "lengthlimit":
          delete validateErrors[e.target.name];
          this.setState({
            lengthLimit: ToReal(e.target.value)
          });
          break;
        case "losslimit":
          delete validateErrors[e.target.name];
          this.setState({
            lossLimit: ToReal(e.target.value)
          });
          break;
        case "refractiveindex":
          this.setState({
            refractiveIndex: ToReal(e.target.value)
          });
          break;
        case "testconfig":
          this.setState({
            testConfig: this.mapEnumValue(e.target.value, "testconfig")
          });
          break;
        default:
          return;
    }
    setTimeout(() => {
      this.onFiberQualificationSave();
    }, 100);
  };

  onFiberQualificationSave = () => {
    const {
      lengthLossLimit,
      fiberType,
      speedType,
      lengthLimit,
      lossLimit,
      refractiveIndex,
      testConfig
    } = this.state;
    const { lengthMeasurementUnit, translate, isTestEdit } = this.props;

    let validationObj = {
      lengthLimit: {
        required: translate("formfield_error_general_required"),
        range: {
          minValue: 0,
          maxValue: lengthMeasurementUnit == "feet" ? 131233.6 : 40000,
          message: lengthMeasurementUnit == "feet" ? translate("fiber_test_maxlength_out_of_range_desc_feet") : translate("fiber_test_maxlength_out_of_range_desc")
        }
      },
      lossLimit: {
        required: translate("formfield_error_general_required"),
        range: {
          minValue: 0,
          maxValue: 18,
          message: translate("fiber_test_loss_limit_range_desc")
        }
      },
      refractiveIndex: {
        required: translate("formfield_error_general_required"),
        range: {
          minValue: 1.3,
          maxValue: 1.55,
          message: translate("fiber_test_refractiveindex_out_of_range_desc")
        }
      },
    };

    let errors = validateFormData(
      { lengthLimit, lossLimit, refractiveIndex },
      validationObj
    );

    const missingFieldName = Object.keys(errors)[0];
    if (missingFieldName) {
      const textField = document.getElementsByName(missingFieldName)[0];
      textField && textField.focus();
    }
    if (Object.keys(errors).length) {
      this.setState({ errors: errors });
      this.props.handleErrors(errors);
    } else {
      const payload = {
        fiberlimit: parseInt(lengthLossLimit[0].key) === 0 ? 1 : parseInt(speedType[0].key),
        fibertype: parseInt(fiberType[0].key),
        maxlength: lengthMeasurementUnit === "feet" ? Math.round((parseFloat(lengthLimit) * 0.3048) * 100) / 100 : parseFloat(lengthLimit),
        fiberattenuation: parseFloat(lossLimit),
        refractiveindex: parseFloat(refractiveIndex),
        stdattenuation: parseInt(lengthLossLimit[0].key) === 0 ? false : true,
        singlefiber: parseInt(testConfig[0].key) == 1 ? true : false
      };
      if (isTestEdit) {
        this.props.updateFiberQualification(this.props.selectedTest, payload);
      }
      this.setState({
        errors: {}
      });
      this.props.handleErrors(errors);
    }
  };

  renderTranslatedValue = (selectedValue, translate) => {
    return selectedValue && selectedValue.length && translate(selectedValue[0].value);
  };

  renderValue = (selectedValue) => {
    return selectedValue && selectedValue.length && selectedValue[0].value;
  };


  render() {
    const {
      translate,
      classes,
      languages,
      selectedTest,
      isTestEdit,
      fiberQualification,
      lengthMeasurementUnit
    } = this.props;
    const {
      lengthLossLimit,
      fiberType,
      speedType,
      lengthLimit,
      lossLimit,
      refractiveIndex,
      fiberQualificationInitialised,
      errors,
      allowedSpeedTypes,
      testConfig
    } = this.state;

    if (!fiberQualificationInitialised) {
      this.updateFiberQualificationStateData(fiberQualification);
      this.setState({fiberQualificationInitialised: true});
      setTimeout(() => {
          this.onFiberQualificationSave();
      }, 100);
    }

    let lengthUnit = lengthMeasurementUnit === "feet" ? translate("ft") : translate("m");

    return (
      <div className={classes.summary}>
      {/* LENGTH & LOSS LIMIT */}
      <FormControl
        className={classes.textField}
        margin="normal"
      >
        <InputLabel id="lengthlosslimit">{translate("fiber_length_loss_limit_type")}</InputLabel>
        <Select
          labelId="lengthlosslimit"
          name="lengthlosslimit"
          renderValue={() => this.renderTranslatedValue(lengthLossLimit, translate)}
          onChange={this.onChange}
          input={
            <Input value={() => this.renderTranslatedValue(lengthLossLimit, translate)} />
          }
          fullWidth
        >
        {FiberQualificationEnum.LengthLossLimit.map(enumType => {
            return (
                <MenuItem key={enumType.value} value={enumType.key}>
                    {translate(enumType.value)}
                </MenuItem>
            );
        })}
        </Select>
      </FormControl>

      <Grid container>
        <Grid item xs={6}>
          {/* FIBER TYPE */}
          <FormControl
            className={classes.textField}
            margin="normal"
          >
            <InputLabel id="fibertype">{translate("fiber_type")}</InputLabel>
            <Select
              labelId="fibertype"
              name="fibertype"
              renderValue={() => this.renderValue(fiberType, translate)}
              onChange={this.onChange}
              input={
                <Input value={() => this.renderValue(fiberType, translate)} />
              }
              style={{width: "50%"}}
            >
            {FiberQualificationEnum.FiberType.map(enumType => {
                return (
                    <MenuItem key={enumType.value} value={enumType.key}>
                        {enumType.value}
                    </MenuItem>
                );
            })}
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={6}>
          {/* REFRACTIVE INDEX */}
          <FormControl
            label={
              <Typography className={classes.textField}>
                {translate("fiber_refractiveindex")}
              </Typography>
            }>
            <TextField
              error={errors.refractiveIndex ? true : false}
              name="refractiveindex"
              label={translate("fiber_refractiveindex")}
              margin="normal"
              fullWidth
              value={refractiveIndex}
              onChange={this.onChange}
              helperText={
                errors.refractiveIndex
                  ? errors.refractiveIndex
                  : ""
              }
            />
          </FormControl>
        </Grid>
        <Grid item xs={6}>
          {/* SPEED */}
          <FormControl
            className={classes.textField}
            margin="normal"
            disabled={this.state.manualLimits}
          >
            <InputLabel id="speedtype">{translate("speed_type")}</InputLabel>
            <Select
              labelId="speedtype"
              name="speedtype"
              renderValue={() => this.renderValue(speedType, translate)}
              onChange={this.onChange}
              input={
                <Input value={() => this.renderValue(speedType, translate)} />
              }
              style={{width: "50%"}}
            >
            {allowedSpeedTypes.map(enumType => {
                return (
                    <MenuItem key={enumType.value} value={enumType.key}>
                        {enumType.value}
                    </MenuItem>
                );
            })}
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={6}>
          {/* TEST CONFIGURATION */}
          <FormControl
            className={classes.textField}
            margin="normal"
          >
            <InputLabel id="testconfig">{translate("fibre_test_configuration")}</InputLabel>
            <Select
              labelId="testconfig"
              name="testconfig"
              renderValue={() => this.renderTranslatedValue(testConfig, translate)}
              onChange={this.onChange}
              input={
                <Input value={() => this.renderTranslatedValue(testConfig, translate)} />
              }
              style={{width: "50%"}}
            >
            {FiberQualificationEnum.TestConfig.map(enumType => {
                return (
                    <MenuItem key={enumType.value} value={enumType.key}>
                        {translate(enumType.value)}
                    </MenuItem>
                );
            })}
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={6}>
          {/* LENGTH LIMIT */}
          {this.state.manualLimits && (
          <FormControl
            label={
              <Typography className={classes.textField}>
                {translate("fiber_lengthlimit") + " (" + lengthUnit + ")"}
              </Typography>
            }>
            <TextField
              error={errors.lengthLimit ? true : false}
              name="lengthlimit"
              label={translate("fiber_lengthlimit") + " (" + lengthUnit + ")"}
              margin="normal"
              fullWidth
              value={lengthLimit}
              onChange={this.onChange}
              helperText={
                errors.lengthLimit
                  ? errors.lengthLimit
                  : ""
              }
            />
          </FormControl>
          )}
        </Grid>
        <Grid item xs={6}>
          {/* LOSS LIMIT */}
          {this.state.manualLimits && (
          <FormControl
            label={
              <Typography className={classes.textField}>
                {translate("fiber_loss_limit") + " (" + translate("dB") + ")"}
              </Typography>
            }>
            <TextField
              error={errors.lossLimit ? true : false}
              name="losslimit"
              label={translate("fiber_loss_limit") + " (" + translate("dB") + ")"}
              margin="normal"
              fullWidth
              value={lossLimit}
              onChange={this.onChange}
              helperText={
                errors.lossLimit
                  ? errors.lossLimit
                  : ""
              }
            />
          </FormControl>
          )}
        </Grid>
      </Grid>
    </div>
  );
  }

  // component life cycles 
  componentWillMount() {
  }

  componentWillReceiveProps(nextProps) {
    const { fiberQualificationInitialised } = this.state
    const { fiberQualification, isTestEdit } = nextProps;
    this.setState( { fiberQualification : nextProps.fiberQualification });
    if (isTestEdit) {
      if (fiberQualification && this.props.fiberQualification != fiberQualification) {
        this.updateFiberQualificationStateData(fiberQualification);
      }
    }
  }


  componentDidMount() {
    window.scrollTo(0, 0)
  }
}

export default withRouter(withStyles(styles)(FiberQualification));
